import { ApiError, isUserFacing, request } from '@/shared/api/client';
import type { BannerDto } from '@/shared/lib/banner';
import { toExchangeResult } from '@/shared/lib/exchange-result';
import type { Shortlink } from './shortlink';

type ProductDto = { code: string; name: string; brandName: string; imageUrl: string };

type ShortUrlResponseDto = {
  redirectUrl: string | null;
  token: string | null;
  status: 'EXCHANGEABLE' | 'USED' | 'CHANGED' | 'CANCELED' | 'EXPIRED' | null;
  products: ProductDto[];
  changedToken: string | null;
  productName: string | null;
  clientName: string | null;
  banners: BannerDto[];
};

export async function resolve(uri: string): Promise<Shortlink | null> {
  try {
    const dto = await request<ShortUrlResponseDto>(`/short-urls/${encodeURIComponent(uri)}`);
    return { ...toExchangeResult(dto, dto.token), token: dto.token };
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) return null;
    if (error instanceof ApiError && error.status >= 400) {
      const show = isUserFacing(error);
      return { status: 'error', message: show ? error.message : '', show, token: null };
    }
    throw error;
  }
}
